<template>
  <div
    v-if="navs"
    class="c-global-footer"
  >
    <div class="c-global-footer__nav-container">
      <div class="l-container">
        <div class="l-grid l-grid--4-col l-grid--align-start u-margin-bottom-large">
          <div
            v-if="socialMedia"
            class="l-grid__item"
          >
            <social-media
              v-bind="socialMedia"
              class="c-global-footer__social"
            />
          </div>
          <template v-for="(nav, index) in navs">
            <global-footer-nav
              v-if="index === 0"
              :key="`nav-item-${index}`"
              :nav="nav"
            >
              <slot v-if="!isCrawler" />
            </global-footer-nav>
            <global-footer-nav
              v-else
              :key="`nav-item-${index}`"
              :nav="nav"
            />
          </template>
        </div>
        <div class="l-flex ">
          <!-- footer images -->
          <div
            v-for="(img, index) in footerImages"
            :key="`footer-image-${index}`"
            class="c-global-footer__footer-image-wrapper"
          >
            <img
              class="c-global-footer__footer-image"
              :src="img.src"
              :alt="img.alt || img.title"
            >
          </div>
          <div class="c-global-footer__yotpo-badge-wrapper">
            <!-- Yotpo Badge -->
            <div
              id="y-badges"
              class="yotpo yotpo-badge badge-init"
            >
  &nbsp;
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="copyright"
      class="c-global-footer__copyright-container"
    >
      <p class="c-global-footer__copyright t-paragraph-small">
        {{ dynamicCopyright }}
      </p>
    </div>
  </div>
</template>

<script>
import SocialMedia from '../socialMedia/SocialMedia'
import GlobalFooterNav from './GlobalFooterNav'
let detectCrawler = null
export default {
  components: {
    GlobalFooterNav,
    SocialMedia
  },
  props: {
    copyright: {
      type: String,
      default: ''
    },
    navs: {
      type: Array,
      default: () => []
    },
    socialMedia: {
      type: Object,
      default: () => ({})
    },
    footerImages: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      detectorReady: 0
    }
  },
  computed: {
    dynamicCopyright() {
      let results = "";
      let date = new Date();
      let year = date.getFullYear();
      if (this.copyright) {
        results = this.copyright;
        if (this.copyright.includes("DATE")) {
          results = results.replace(/DATE/g, year);
        }
      }
      return results;
    },
    isCrawler() {
      const detectorReady = this.detectorReady
      let result = true
      if (
        process.client &&
        window.navigator &&
        detectorReady
      ) {
        result = detectCrawler(window.navigator.userAgent)
      }
      return result
    }
  },
  async created() {
    if (detectCrawler === null) {
      const mod = await import('@/utils/detect-crawler')
      detectCrawler = mod.default
      this.detectorReady += 1
    } if (detectCrawler) {
      this.detectorReady += 1
    }
  },
}
</script>

<style lang="scss" scoped>
.c-global-footer {
  @include respond(tab-land) {
    text-align: center;
  }

  &__nav-container {
    padding: $section-padding;
  }

  &__copyright-container {
    padding: rem(10px);

    @include themify($themes) {
      color: themed("foreground", "white-text");
      background-color: themed("background", 'dark');
    }
  }
  &__copyright {
    max-width: rem(200px);
    margin: auto;
    text-align: center;
  }
  &__footer-image-wrapper,
  &__yotpo-badge-wrapper {
    width: rem(200px);
  }
  &__footer-image {
    height: rem(100px);
  }
}
</style>
